import {
  UPDATE_ONBOARDING_FORM,
  INITIALIZE_ONBOARDING
} from './types'

// Form Inialization
export const initalizeOnboarding = () => (dispatch) => {
  dispatch(startOnboarding())
}

const startOnboarding = () => ({
  type: INITIALIZE_ONBOARDING
});

// Update Form
export const updateForm = (partialFormData) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateOnboardingForm(partialFormData))

    let responseObject = {
      success: true
    }
    resolve(responseObject)
  })
}

const updateOnboardingForm = (form) => ({
  type: UPDATE_ONBOARDING_FORM,
  form
});



// WEBPACK FOOTER //
// ./src/actions/onboarding.js